/* Hjälpfunktionalitet för att lagra data i local storage. */
class Storage {
    static set = (id, data) => {
        localStorage.setItem(id, JSON.stringify(data));
    }

    static get = (id) => {
        let data = localStorage.getItem(id);
        if (data !== null) {
            return JSON.parse(data);
        }
        return null;
    }

    static delete = (id) => {
        localStorage.removeItem(id);
    }
}

export default Storage;
